import { Alert, Zoom } from "@mui/material";
import { useEffect, useMemo } from "react";
import { DataGrid, DataGridProps } from "@mui/x-data-grid";
import { alpha, createTheme, styled, ThemeProvider, useTheme } from '@mui/material/styles';
import * as Colors from "@mui/material/colors";
import { arSD, enUS, zhCN } from '@mui/x-data-grid/locales';
import { useApp } from "../contexts/AppContext";

const ODD_OPACITY = 0.2;

// const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
//     '& .MuiDataGrid-columnHeadersInner': {
//         fontSize: 20,
//         backgroundColor: theme.palette.primary.main,
//         color: theme.palette.primary.contrastText
//     },
//     '& .MuiDataGrid-footerContainer': {
//         backgroundColor: theme.palette.primary.main,
//         color: theme.palette.primary.contrastText
//     },
//     '& .MuiTablePagination-root': {
//         color: theme.palette.primary.contrastText
//     },
//     [`& .${gridClasses.row}.even`]: {
//         fontSize: 16,
//         backgroundColor: theme.palette.common.white,
//         '&:hover, &.Mui-hovered': {
//             backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
//             '@media (hover: none)': {
//                 backgroundColor: 'transparent',
//             },
//         },
//         color: '#000000',
//         '&.Mui-selected': {
//             backgroundColor: Colors.grey[400],
//             '&:hover, &.Mui-hovered': {
//                 backgroundColor: Colors.grey[300],
//                 // Reset on touch devices, it doesn't add specificity
//                 '@media (hover: none)': {
//                     backgroundColor: alpha(
//                         theme.palette.primary.main,
//                         ODD_OPACITY + theme.palette.action.selectedOpacity,
//                     ),
//                 },
//             },
//         },
//     },
//     [`& .${gridClasses.row}.odd`]: {
//         fontSize: 16,
//         backgroundColor: theme.palette.primary.light,
//         '&:hover, &.Mui-hovered': {
//             backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
//             '@media (hover: none)': {
//                 backgroundColor: 'transparent',
//             },
//         },
//         color: '#000000',
//         '&.Mui-selected': {
//             backgroundColor: Colors.grey[400],
//             '&:hover, &.Mui-hovered': {
//                 backgroundColor: Colors.grey[300],
//                 // Reset on touch devices, it doesn't add specificity
//                 '@media (hover: none)': {
//                     backgroundColor: alpha(
//                         theme.palette.primary.main,
//                         ODD_OPACITY + theme.palette.action.selectedOpacity,
//                     ),
//                 },
//             },
//         },
//     },
// }));

/**
 * Your custom DataGrid component.
 * @param {...(import('@mui/x-data-grid').DataGridProps)} props - Props for the custom DataGrid.
 * @returns {React.ReactElement} The rendered custom DataGrid.
 */

export default function StyledDataGrid(props: DataGridProps) {
    const { lang } = useApp()
    const theme = useTheme()

    const dgTheme = useMemo(
        () =>
            createTheme({}, lang === 'ar' ? arSD : lang === 'zh' ? zhCN : enUS, theme),
        [theme, lang],
    );

    return (
        <ThemeProvider theme={dgTheme}>
            <DataGrid
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 10,
                        },
                    },
                }}
                pageSizeOptions={[5, 10, 20]}
                getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                }
                {...props}

                sx={({
                    ...({
                        backgroundColor: "rgba(255, 255, 255, 0.5)",
                        borderRadius: 4,
                        '& .MuiDataGrid-columnHeader': {
                            fontSize: 16,
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                        },
                        '& .MuiDataGrid-footerContainer': {
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText
                        },
                        '& .MuiTablePagination-root': {
                            color: theme.palette.primary.contrastText
                        },
                        '& .MuiDataGrid-row.even': {
                            // fontSize: 16,
                            backgroundColor: theme.palette.common.white,
                            '&:hover, &.Mui-hovered': {
                                backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent',
                                },
                            },
                            color: '#000000',
                            '&.Mui-selected': {
                                backgroundColor: Colors.grey[400],
                                '&:hover, &.Mui-hovered': {
                                    backgroundColor: Colors.grey[300],
                                    // Reset on touch devices, it doesn't add specificity
                                    '@media (hover: none)': {
                                        backgroundColor: alpha(
                                            theme.palette.primary.main,
                                            ODD_OPACITY + theme.palette.action.selectedOpacity,
                                        ),
                                    },
                                },
                            },
                        },
                        '& .MuiDataGrid-row.odd': {
                            // fontSize: 16,
                            backgroundColor: alpha(theme.palette.secondary.light, ODD_OPACITY),
                            '&:hover, &.Mui-hovered': {
                                backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent',
                                },
                            },
                            color: '#000000',
                            '&.Mui-selected': {
                                backgroundColor: Colors.grey[400],
                                '&:hover, &.Mui-hovered': {
                                    backgroundColor: Colors.grey[300],
                                    // Reset on touch devices, it doesn't add specificity
                                    '@media (hover: none)': {
                                        backgroundColor: alpha(
                                            theme.palette.primary.main,
                                            ODD_OPACITY + theme.palette.action.selectedOpacity,
                                        ),
                                    },
                                },
                            },
                        },
                    }), ...props.sx
                })}
            />
        </ThemeProvider>
    )
}